/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedResponse_TaskPerformanceResponse_ } from '../models/PaginatedResponse_TaskPerformanceResponse_';
import type { TaskPerformanceCreateRequest } from '../models/TaskPerformanceCreateRequest';
import type { TaskPerformanceCreateResponse } from '../models/TaskPerformanceCreateResponse';
import type { TaskPerformanceResponse } from '../models/TaskPerformanceResponse';
import type { TaskPerformanceUpdateRequest } from '../models/TaskPerformanceUpdateRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TaskPerformanceService {
    /**
     * Create Task Performance
     * 세부실행과제 성과 생성 (성과 항목 포함 가능)
     *
     * 새로운 세부실행과제 성과를 생성합니다.
     * 선택적으로 성과 항목들도 함께 생성할 수 있습니다.
     *
     * Args:
     * data: 성과 생성 요청 데이터
     * - task_id: 세부실행과제 ID
     * - name: 성과명
     * - unit: 단위
     * - items: 성과 항목 목록 (선택사항)
     *
     * Returns:
     * 201: 생성된 성과 및 항목 정보
     * 400: 잘못된 요청 데이터
     * 401: 인증 실패
     * 409: 중복 데이터
     * 500: 서버 내부 오류
     * @returns TaskPerformanceCreateResponse Created
     * @throws ApiError
     */
    public static appsTaskViewsCreateTaskPerformance({
        requestBody,
    }: {
        requestBody: TaskPerformanceCreateRequest,
    }): CancelablePromise<TaskPerformanceCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/task/performance',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List Task Performances
     * 세부실행과제 성과 목록 조회 및 검색
     *
     * 세부실행과제 성과를 페이징하여 조회하거나 키워드로 검색합니다.
     *
     * Args:
     * workspace_id: 워크스페이스 ID (필수)
     * q: 검색 키워드 (선택사항)
     * task_id: 세부실행과제 ID로 필터링 (선택사항)
     * page: 페이지 번호 (기본값: 1)
     * per_page: 페이지당 항목 수 (기본값: 50)
     * start_date: 시작일 (YYYY-MM-DD 형식, 선택사항)
     * end_date: 종료일 (YYYY-MM-DD 형식, 선택사항)
     * department_id: 부서 ID로 필터링 (선택사항)
     * business_id: 사업 ID로 필터링 (선택사항)
     * assignee_id: 담당자 ID로 필터링 (선택사항)
     * sub_assignee_id: 부담당자 ID로 필터링 (선택사항)
     * manager_id: 관리자 ID로 필터링 (선택사항)
     * reviewer_id: 검토자 ID로 필터링 (선택사항)
     * stakeholder_id: 이해관계자 ID (OR 조건으로 모든 역할 검색, 선택사항)
     * status: 성과 상태 (completed | incomplete, 선택사항)
     * @returns PaginatedResponse_TaskPerformanceResponse_ OK
     * @throws ApiError
     */
    public static appsTaskViewsListTaskPerformances({
        workspaceId,
        q,
        taskId,
        page = 1,
        perPage = 100,
        startDate,
        endDate,
        departmentId,
        businessId,
        assigneeId,
        subAssigneeId,
        managerId,
        reviewerId,
        stakeholderId,
        status,
    }: {
        workspaceId: string,
        q?: string,
        taskId?: string,
        page?: number,
        perPage?: number,
        startDate?: string,
        endDate?: string,
        departmentId?: string,
        businessId?: string,
        assigneeId?: string,
        subAssigneeId?: string,
        managerId?: string,
        reviewerId?: string,
        stakeholderId?: string,
        status?: string,
    }): CancelablePromise<PaginatedResponse_TaskPerformanceResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/performance',
            query: {
                'workspace_id': workspaceId,
                'q': q,
                'task_id': taskId,
                'page': page,
                'per_page': perPage,
                'start_date': startDate,
                'end_date': endDate,
                'department_id': departmentId,
                'business_id': businessId,
                'assignee_id': assigneeId,
                'sub_assignee_id': subAssigneeId,
                'manager_id': managerId,
                'reviewer_id': reviewerId,
                'stakeholder_id': stakeholderId,
                'status': status,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Task Performance
     * 세부실행과제 성과 조회
     *
     * ID로 특정 세부실행과제 성과를 조회합니다.
     * @returns TaskPerformanceResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsGetTaskPerformance({
        taskPerformanceId,
    }: {
        taskPerformanceId: string,
    }): CancelablePromise<TaskPerformanceResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/performance/{task_performance_id}',
            path: {
                'task_performance_id': taskPerformanceId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Task Performance
     * 세부실행과제 성과 정보 수정
     *
     * 특정 세부실행과제 성과의 정보를 수정합니다.
     * @returns TaskPerformanceResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsUpdateTaskPerformance({
        taskPerformanceId,
        requestBody,
    }: {
        taskPerformanceId: string,
        requestBody: TaskPerformanceUpdateRequest,
    }): CancelablePromise<TaskPerformanceResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/task/performance/{task_performance_id}',
            path: {
                'task_performance_id': taskPerformanceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete Task Performance
     * 세부실행과제 성과 삭제
     *
     * 특정 세부실행과제 성과를 삭제합니다. (소프트 삭제)
     * @returns void
     * @throws ApiError
     */
    public static appsTaskViewsDeleteTaskPerformance({
        taskPerformanceId,
    }: {
        taskPerformanceId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/task/performance/{task_performance_id}',
            path: {
                'task_performance_id': taskPerformanceId,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
